<template>
  <div>
    <!-- content -->
    <div v-if="detail != ''">
      <section class="info">
        <h3>基本信息</h3>
        <ul>
          <li>
            <label>项目：</label>
            <p>{{ detail.project_name }}</p>
          </li>
          <li>
            <label>名称：</label>
            <p>{{ detail.name }}</p>
          </li>
          <li>
            <label>地址：</label>
            <p>
              {{
                detail.province == detail.city
                  ? detail.city + detail.area + detail.address
                  : detail.province + detail.city + detail.area + detail.address
              }}
            </p>
          </li>
          <li>
            <label>计划服务时间：</label>
            <p>{{ detail.plan_work_date }}</p>
          </li>
          <li v-show="detail.status != 10">
            <label>保洁员工：</label>
            <p>{{ detail.guard_user_name }}</p>
          </li>
          <li>
            <label>工单类型：</label>
            <p v-if="detail.type == 1">开荒</p>
            <p v-else-if="detail.type == 2">双周</p>
            <p v-else-if="detail.type == 3">深度</p>
            <p v-else-if="detail.type == 4">退租</p>
          </li>
          <li v-if="detail.type == 4">
            <label>退租类型：</label>
            <p v-if="detail.return_type == 1">整套退租</p>
            <p v-else-if="detail.return_type == 2">单间退租</p>
            <p v-else-if="detail.return_type == 3">无房间退租</p>
          </li>
          <li v-if="detail.type == 4 && detail.return_type == 2">
            <label>退租房间编号：</label>
            <p>{{ detail.return_simple_number }}</p>
          </li>
          s
          <li
            v-if="
              detail.type == 4 &&
                (detail.return_type == 1 || detail.return_type == 2)
            "
          >
            <label>独卫数量：</label>
            <p>{{ detail.return_simple_wc }}</p>
          </li>
          <li v-if="detail.type == 4">
            <label>是否包含公共区域：</label>
            <p v-if="detail.return_include_public == 1">包含</p>
            <p v-else-if="detail.return_include_public == 2">不包含</p>
          </li>
          <li>
            <label>工单状态：</label>
            <p v-if="detail.status == 0">未填</p>
            <p v-else-if="detail.status == 10">待分配</p>
            <p v-else-if="detail.status == 20">未完成</p>
            <p v-else-if="detail.status == 30">已完成</p>
            <p v-else-if="detail.status == 40">退单</p>
            <p v-else-if="detail.status == 50">返单</p>
          </li>
          <li v-if="detail.end_time != 0 && detail.end_time != undefined">
            <label>工单完成时间：</label>
            <p>{{ detail.end_time == 0 ? "" : detail.end_time }}</p>
          </li>
          <li>
            <label>备注：</label>
            <p>
              {{
                detail.remark == ""
                  ? detail.content
                  : detail.remark + "；" + detail.content
              }}
            </p>
          </li>
          <li class="attention" v-show="detail.is_order_notice == 2">
            <label>注意事项图片：</label>
            <viewer :images="detail.images_fmt">
              <img
                class="imgStyle"
                v-for="src in detail.images_fmt"
                :src="src.url"
                :key="src.id"
              />
            </viewer>
          </li>
          <br />
          <li v-show="detail.status != 10">
            <label>派单时间：</label>
            <p>{{ detail.assign_time }}</p>
          </li>
          <li v-show="detail.status != 10">
            <label>派单人员：</label>
            <p>{{ detail.assign_user_name }}</p>
          </li>
        </ul>
      </section>
      <section class="info">
        <h3>公寓信息</h3>
        <ul>
          <li>
            <label>密码类型：</label>
            <p v-if="detail.password_type == 2">临时密码</p>
            <p v-else-if="detail.password_type == 1">固定密码</p>
          </li>
          <li v-if="detail.password_type == 1">
            <label>密码：</label>
            <p>{{ detail.password }}</p>
          </li>
          <li>
            <label>公寓类型：</label>
            <p>{{ detail.room + "室户" }}</p>
          </li>
          <li>
            <label>房间编号：</label>
            <p>{{ detail.room_number }}</p>
          </li>
          <li>
            <label>洗手间类型：</label>
            <p v-if="detail.washroom_type == 1">单卫</p>
            <p v-else-if="detail.washroom_type == 2">双卫</p>
            <p v-else-if="detail.washroom_type == 3">三卫</p>
          </li>
          <li>
            <label>公寓类型：</label>
            <p v-if="detail.is_compound == 1">复式</p>
            <p v-else-if="detail.is_compound == 2">非复式</p>
          </li>
          <li>
            <label>公寓备注：</label>
            <p>{{ detail.house_remark }}</p>
          </li>
        </ul>
      </section>
      <section class="info" v-if="detail.status == 30 || detail.status == 50">
        <h3>结算信息</h3>
        <ul>
          <li>
            <label>甲方预计价格：</label>
            <p>{{ Number(detail.pre_three) + "元" }}</p>
          </li>
          <li>
            <label>甲方奖励：</label>
            <p>{{ Number(detail.reward_three) + "元" }}</p>
          </li>
          <li>
            <label>甲方惩罚：</label>
            <p>{{ Number(detail.punish_three) + "元" }}</p>
          </li>
          <!-- <li>
            <label>员工预计价格：</label>
            <p>{{ Number(detail.pre_guard) + "元" }}</p>
          </li>
          <li>
            <label>员工奖励：</label>
            <p>{{ Number(detail.reward_guard) + "元" }}</p>
          </li>
          <li>
            <label>员工惩罚：</label>
            <p>{{ Number(detail.punish_guard) + "元" }}</p>
          </li> -->
          <li>
            <label>甲方实际结算：</label>
            <p>{{ Number(detail.checked_three) + "元" }}</p>
          </li>
          <!-- <li>
            <label>员工实际结算：</label>
            <p>{{ Number(detail.checked_guard) + "元" }}</p>
          </li> -->
          <br />
          <li v-show="detail.check_remark != ''">
            <label>备注：</label>
            <p>{{ detail.check_remark }}</p>
          </li>
        </ul>
      </section>
      <section
        class="info"
        v-if="detail.order_handle != '' || detail.guard_apply != ''"
      >
        <h3>操作日志</h3>
        <ul class="log">
          <li v-if="detail.guard_apply != ''">
            <h4><a-icon type="file-done" />退单/改期申请记录</h4>
          </li>
          <li v-for="(item, n) in detail.guard_apply" :key="n + 1">
            <label>{{ n + 1 + "." }}</label>
            <label>操作时间:</label>
            <p>{{ item.create_time + "；&nbsp;" }}</p>
            <label>原因:</label>
            <p>{{ item.reason }}</p>
          </li>
          <li v-if="detail.order_handle != ''">
            <h4><a-icon type="file-done" />异常工单处理</h4>
          </li>
          <li v-for="(item, o) in detail.order_handle" :key="o + '1'">
            <label>{{ o + 1 + "." }}</label>
            <label>操作时间：</label>
            <p>{{ item.create_time + "；" }}</p>
            <label>操作人：</label>
            <p>{{ item.check_user_id + "；" }}</p>
            <label>状态：</label>
            <p v-if="item.result_type == 1">改期；</p>
            <p v-else-if="item.result_type == 2">退单；</p>
            <p v-else-if="item.result_type == 3">返单；</p>
            <p v-else-if="item.result_type == 4">转派；</p>
            <label v-show="item.result_reason != ''">原因：</label>
            <p v-show="item.result_reason != ''">
              {{ item.result_reason + "；" }}
            </p>
            <label v-show="item.result_type == 1">原计划服务时间：</label>
            <p v-show="item.result_type == 1">
              {{ item.old_plan_date.substring(0, 10) + "；" }}
            </p>
            <label v-show="item.result_type == 1">现计划服务时间：</label>
            <p v-show="item.result_type == 1">
              {{ item.now_plan_date.substring(0, 10) + "；" }}
            </p>
            <label v-show="item.result_type == 4">原员工：</label>
            <p v-show="item.result_type == 4">{{ item.guard_name + "；" }}</p>
            <label v-show="item.result_type == 4">现员工：</label>
            <p v-show="item.result_type == 4">
              {{ item.to_guard_name + "；" }}
            </p>
          </li>
        </ul>
      </section>
      <section class="info" v-if="detail.guard_order_status != 0">
        <h3>签到信息</h3>
        <ul class="signStyle">
          <li>
            <label>个人形象照：</label>
            <viewer :images="person_img_url">
              <img
                class="imgStyle"
                v-for="src in person_img_url"
                :src="src"
                :key="src"
              />
            </viewer>
          </li>
          <li>
            <label>工具包：</label>
            <viewer :images="tool_img_url">
              <img
                class="imgStyle"
                v-for="src in tool_img_url"
                :src="src"
                :key="src"
              />
            </viewer>
          </li>
          <li v-if="detail.type == 2">
            <label>签到表：</label>
            <viewer :images="sign_img_url">
              <img
                class="imgStyle"
                v-for="src in sign_img_url"
                :src="src"
                :key="src"
              />
            </viewer>
          </li>
        </ul>
      </section>
      <section class="info" v-if="detail.guard_order_status != 0">
        <h3>保洁前</h3>
        <ul class="clean">
          <li>
            <div>
              <viewer :images="clean_before_url">
                <img
                  class="imgStyle"
                  v-for="src in clean_before_url"
                  :src="src.url"
                  :key="src.id"
                />
              </viewer>
            </div>
          </li>
        </ul>
      </section>
      <section class="info cleanAfter" v-if="detail.guard_order_status == 2">
        <h3>保洁后</h3>
        <ul class="clean">
          <li v-if="detail.type == 1 || detail.type == 2">
            <label>厨房：</label>
            <viewer :images="kitchen">
              <img
                class="imgStyle"
                v-for="src in kitchen"
                :src="src.url"
                :key="src.id"
              />
            </viewer>
          </li>
          <li v-if="detail.type == 1 || detail.type == 2">
            <label>卫生间：</label>
            <viewer :images="toilet">
              <img
                class="imgStyle"
                v-for="src in toilet"
                :src="src.url"
                :key="src.id"
              />
            </viewer>
          </li>
          <li>
            <label>公共区域：</label>
            <viewer :images="publicArea">
              <img
                class="imgStyle"
                v-for="src in publicArea"
                :src="src.url"
                :key="src.id"
              />
            </viewer>
          </li>
          <li v-if="detail.type == 1 || detail.type == 4">
            <label>房间：</label>
            <viewer :images="room">
              <img
                class="imgStyle"
                v-for="src in room"
                :src="src.url"
                :key="src.id"
              />
            </viewer>
          </li>
        </ul>
      </section>
      <section class="info" v-if="detail.guard_order_status == 2">
        <h3>反馈</h3>
        <ul>
          <li>
            <label>违约情况：</label>
            <p v-show="group != ''" v-for="(element, i) in group" :key="i">
              <span v-if="element == 1">6岁以下儿童;&nbsp;</span>
              <span v-else-if="element == 2">宠物;&nbsp;</span>
              <span v-else-if="element == 3">40岁以上成人;&nbsp;</span>
              <span v-else-if="element == 4">群租(两人以上);&nbsp;</span>
            </p>
            <p v-show="group == ''">无</p>
          </li>
          <li>
            <label>反馈备注：</label>
            <p>
              {{ detail.repair_report == "" ? "无" : detail.repair_report }}
            </p>
          </li>
        </ul>
      </section>
    </div>
    <!-- content end -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      person_img_url: [],
      tool_img_url: [],
      sign_img_url: [],
      group: [],
      clean_before_url: [],
      kitchen: [],
      toilet: [],
      publicArea: [],
      room: []
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      // console.log(this.detailVal);
      this.detail = this.detailVal;
      this.getDetail();
    }
  },
  mounted() {
    this.detail = this.detailVal;
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.person_img_url = [];
      this.sign_img_url = [];
      this.tool_img_url = [];
      // this.group = this.detail.report_type.replace("[", "");
      // this.group = this.group.replace("]", "");
      // this.group = this.group.split("").map(Number);
      if (this.detail.guard_order_status != 0) {
        this.person_img_url.push(this.detail.person_img_url);
        this.tool_img_url.push(this.detail.tool_img_url);
        this.sign_img_url.push(this.detail.sign_img_url);
        this.clean_before_url = this.detail.clean_before_url;
      }
      if (this.detail.guard_order_status == 2) {
        if (this.detail.type == 1 || this.detail.type == 2) {
          this.kitchen = this.detail.clean_after_url.kitchen;
          this.toilet = this.detail.clean_after_url.toilet;
        }
        this.publicArea = this.detail.clean_after_url.public;
        if (this.detail.type == 1 || this.detail.type == 4) {
          this.room = this.detail.clean_after_url.room;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.info {
  margin: 30px 2% 0;
  h3 {
    line-height: 24px;
  }
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      margin-bottom: 4px;
      vertical-align: top;
      label,
      p {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        max-width: 260px;
        vertical-align: top;
      }
    }
  }
  .signStyle {
    img {
      display: block;
      height: 200px;
      width: 200px;
      object-fit: cover;
    }
  }

  .clean {
    > li {
      display: block;
      label {
        display: block;
        margin-bottom: -10px;
      }
      h4 {
        display: block;
        font-size: 32px;
        line-height: 52px;
        margin: 10px 0;
      }
      img {
        width: 200px;
        height: 200px;
        margin-right: 20px;
        margin-top: 20px;
        object-fit: cover;
      }
    }
  }
  .attention {
    > div {
      display: inline-block;
      vertical-align: top;
      img {
        width: 120px;
        height: 120px;
        margin-right: 20px;
        margin-bottom: 20px;
        object-fit: cover;
        border: 1px solid #d9d9d9;
      }
    }
  }
  .log {
    > li {
      display: block;
      h4 {
        font-size: 14px;
        line-height: 22px;
        i {
          margin-top: 4px;
        }
      }
      label,
      p {
        display: inline-block;
      }
      p {
        margin-right: 10px;
      }
    }
  }
}
.cleanAfter {
  > ul {
    > li {
      margin-bottom: 20px;
    }
  }
}
</style>
